/**
 * Test result status
 */
export enum RcaTestValidationStatus {
  Success = "Success",
  Failed = "Failed",
  Warning = "Warning",
  Skipped = "Skipped",
}
